module.exports = __webpack_public_path__ + "65ab482902466242a40b397c0b4603ca.png";